<template>
    <div class="external-activity--card external-activity--card-full-width" :style="`border-radius: ${activity.card_border_radius}px`">
        <div class="external-activity--card-content" v-if="parent && !isFinal">
            <h4>{{ findValueFromCode(parent, 'title', language, defaultLanguage, false) }}</h4>
            <p v-html="findValueFromCode(parent, 'description', language, defaultLanguage, true)"></p>
            <span class="single--tag" :value="tag.id" v-for="tag in parent.tags" v-if="tag.language_id == language.id">{{ tag.name }}</span>
            <template v-if="parent.restaurant">
                <div
                    style="font-size: 12px; margin-top: 10px;"
                    :class="parent.restaurant.opening_status.open ? 'text-success' : 'text-danger'">
                    {{ parent.restaurant.opening_status.label }}
                </div>
            </template>
        </div>
        <!-- <div class="external-activity--card-label" v-if="displayableContent.length > 0">Menu</div> -->
        <div v-for="(item, index) in displayableContent" v-if="item.active">
            <div class="external-activity--card-item" style="display: flex; padding: 20px 6px;"  :class="{'in-cart' : isInCart(item.uuid)}" @click="localSetPreviewableCartItem(item)">
                <div class="external-activity--card-item-info">
                <!-- <div class="external-activity--card-item-info" style="height: 110px"> -->
                    <template v-if="identifyLink(item)">
                        <a :href="identifyLink(item)" target="_blank">
                            <h4 class="external-link">
                                {{ findValueFromCode(item, 'title', language, defaultLanguage, false) }}
                                <!--<i class="fal fa-external-link"></i>-->
                            </h4>
                        </a>
                    </template>
                    <p v-else style="margin-bottom: 0"><strong>{{ findValueFromCode(item, 'title', language, defaultLanguage, false) }}</strong></p>

                    <template v-if="item.restaurant && item.restaurant.content_id == item.id">
                        <div v-if="item.restaurant.opening_status.open"
                            style="font-size: 12px; margin-top: 10px;"
                            class="text-success">
                            {{ defaultCartLanguage.restaurant_closes }} {{ defaultCartLanguage.restaurant_at }} {{ item.restaurant.opening_status.time }}
                        </div>
                        <div v-else
                            style="font-size: 12px; margin-top: 10px;"
                            class="text-danger">
                            {{ defaultCartLanguage.restaurant_opens }}
                            {{ defaultCartLanguage.days[item.restaurant.opening_status.day] }} {{ defaultCartLanguage.restaurant_at }} {{ item.restaurant.opening_status.time }}
                        </div>
                    </template>
                    
                    <p v-html="findValueFromCode(item, 'description', language, defaultLanguage, true)"></p>
                    <!-- <p style="height: 98px" v-html="findValueFromCode(item, 'description', language, defaultLanguage, true)"></p> -->
                    <!-- <Tags :tags="item.tags" :languageId="language.id"/> -->

                    <h6 v-if="item.price" style="font-size: 14px; line-height: 14px">€ {{ item.price }}</h6>
                </div>
                <div class="external-activity--card-item-image" v-if="item.media.length > 0" :style="`background: url(${item.media[0].url}); border-radius: 4px; margin-top: 0`"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import Tags from './Tags'
    import { mapActions, mapGetters } from 'vuex'
    export default {
        props: [
            'activity',
            'parent',
            'language',
            'defaultLanguage',
            'defaultCartLanguage',
            'nl2br',
            'displayableContent',
            'identifyLink',
            'isFinal',
            'findValueFromCode',
        ],

        components: {
            Tags
        },

        methods: {
            ...mapActions(['setPreviewableCartItem']),
            isInCart (uuid) {
                return this.cartUuids.indexOf(uuid) !== -1
            },

            localSetPreviewableCartItem(item) {
                //if(!item.restaurant || item.restaurant.opening_status.open){
                if (this.activity.is_shop || (item.restaurant && item.restaurant.opening_status.open && item.restaurant.business_model != 'paper')) {
                    this.setPreviewableCartItem(item)
                }
            }
        },

        computed: {
            ...mapGetters(['cartUuids']),
        }

    }
</script>
<style>
    .in-cart {
        border-left: 4px solid #01AD83!important;
    }
</style>
